import { onMounted, onBeforeUnmount } from 'vue'
import { Capacitor, SystemBars, SystemBarsStyle, type PluginListenerHandle } from '@capacitor/core'
import { App } from '@capacitor/app'
import type { Router } from 'vue-router'
import { usePlatform } from './usePlatform'

const overlays: Array<() => void> = []
export function registerOverlayBackHandler(close: () => void) {
  overlays.push(close)
  return () => {
    const index = overlays.lastIndexOf(close)
    if (index !== -1) overlays.splice(index, 1)
  }
}

export function useNativeUI(router: Router) {
  const { isNative, isAndroid } = usePlatform()
  let backListener: PluginListenerHandle | undefined
  let disposed = false
  onMounted(async () => {
    if (!isNative) return
    if (Capacitor.isPluginAvailable('SystemBars')) {
      await SystemBars.setStyle({ style: SystemBarsStyle.Light }).catch(() => undefined)
    }
    if (isAndroid && Capacitor.isPluginAvailable('App')) {
      const listener = await App.addListener('backButton', ({ canGoBack }) => {
        const closeOverlay = overlays[overlays.length - 1]
        if (closeOverlay) closeOverlay()
        else if (canGoBack) router.back()
        else void App.minimizeApp()
      })
      if (disposed) void listener.remove()
      else backListener = listener
    }
  })
  onBeforeUnmount(() => {
    disposed = true
    void backListener?.remove()
  })
}
